module.exports = __webpack_public_path__ + "static/media/logout.4a9485b5.svg";